import { useContext } from "react";
import { sass } from "../../sass/sass.js";
import { WindowSizeContext } from "./WindowSizeContext.js";
import "react/jsx-runtime";
import "../../utils/noOp.js";
import "../../isObject-ec23ace2.js";
import "../../isSymbol-c6f5cd95.js";
function useWindowSize() {
  const { state } = useContext(WindowSizeContext), { windowWidth, windowHeight } = state, windowIsMobile = isWindowMobile(windowWidth), windowIsMobileLandscape = isWindowMobileLandscape(windowWidth), windowIsTablet = isWindowTablet(windowWidth), windowIsDesktop = isWindowDesktop(windowWidth);
  return { windowWidth, windowHeight, windowIsMobile, windowIsMobileLandscape, windowIsTablet, windowIsDesktop };
}
const { breakpoints } = sass, { mobile_portrait, mobile_landscape, tablet } = breakpoints;
function isWindowMobile(windowWidth) {
  return windowWidth < mobile_portrait;
}
function isWindowMobileLandscape(windowWidth) {
  return windowWidth >= mobile_portrait && windowWidth < mobile_landscape;
}
function isWindowTablet(windowWidth) {
  return windowWidth >= mobile_landscape && windowWidth < tablet;
}
function isWindowDesktop(windowWidth) {
  return windowWidth >= tablet;
}
export {
  useWindowSize
};
//# sourceMappingURL=useWindowSize.js.map
